import React, {createContext, useContext, useState } from "react"

const ResendDocsContext = createContext();
export const useResendDocs = () => useContext(ResendDocsContext);

export default function ResendDocsProvider({ payload, resendDocsDTO, children, }) {
  const [response, setResponse] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const resendDocs = async () => {
    setLoading(true);
    const ac = new AbortController();
    try {
      const resendDocsResp = await resendDocsDTO(payload);
      if (resendDocsResp?.data) {
        setResponse(resendDocsResp.data);
      }
      setErrorMessage(null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMessage(error.message);
      return () => ac.abort();
    }
  };

  return (
    <ResendDocsContext.Provider value={{ response, errorMessage, isLoading, resendDocs }}>
      {children}
    </ResendDocsContext.Provider>
  );
};